import { Component, OnInit, inject } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'adm-note-creation-modal',
  templateUrl: './note-creation-modal.component.html',
  styleUrls: ['./note-creation-modal.component.scss'],
  imports: [ReactiveFormsModule, MatDialogModule, MatIconModule, MatButtonModule, MatFormFieldModule, MatInputModule],
})
export class NoteCreationModalComponent implements OnInit {
  dialogRef = inject<MatDialogRef<NoteCreationModalComponent>>(MatDialogRef);
  data = inject<{
    title: string;
    confirmText: string;
    denyText: string;
    icon?: string | { name: string };
  }>(MAT_DIALOG_DATA);

  title: string;
  confirmText: string;
  denyText: string;
  icon?: string | { name: string };

  get isStringIcon(): boolean {
    return typeof this.icon === 'string';
  }

  get isObjectIcon(): boolean {
    return typeof this.icon === 'object' && this.icon !== null;
  }

  get iconName(): string | null {
    return this.isObjectIcon ? (this.icon as { name: string }).name : null;
  }

  public noWhiteSpaceValidator(control: AbstractControl): ValidationErrors | null {
    return (control.value || '').trim().length ? null : { whitespace: true };
  }

  public formGroup: FormGroup = new FormGroup({
    noteField: new FormControl<string>('', { validators: [Validators.required, Validators.maxLength(1000), this.noWhiteSpaceValidator] }),
  });

  get noteField() {
    return this.formGroup.controls['noteField'];
  }

  get canConfirm() {
    if (!this.noteField?.value) return false;
    if (this.noteField?.value?.trim().length < 1) return false;
    if (this.noteField?.value?.length > 1000) return false;
    return true;
  }

  ngOnInit() {
    this.title = this.data?.title;
    this.confirmText = this.data?.confirmText;
    this.denyText = this.data?.denyText;
    this.icon = this.data?.icon;
  }

  confirm() {
    this.dialogRef.close(this.noteField.value);
  }

  close() {
    this.dialogRef.close(false);
  }
}
